const language = {
	spanish: {
		header_title: "Manejo de ",
		header_title_yellow: "Flotas",
		flotas_red_title: "MANEJO DE FLOTAS",
		flotas_bold_title:
			"El manejo de flotas comerciales suele ser un proceso complejo debido a la magnitud de los activos móviles y todos los factores que se deben controlar al mismo tiempo",
		flotas_bold_text:
			"Por eso, en Foresight GPS hemos desarrollado una plataforma que se adapta a sus necesidades y le permite acceder y gestionar los valores más importantes de su flota comercial.",
		flotas_text: [
			"La plataforma de G-Evolution te garantiza el ahorro de combustible y la eficiencia de su flota con la solución de seguimiento de rutas.",
			"Nuestras plataformas son totalmente personalizables y adaptables según sus necesidades, permitiéndole tomar decisiones más rápidas para el beneficio de su negocio.",
		],
		beneficios_red_title: "BENEFICIOS",
		beneficios_bold_text:
			"Proteja sus activos móviles y comerciales con los múltiples beneficios que Foresight GPS le ofrece como:",
		beneficios_list: [
			{
				text: "Reducir los costos de mantenimiento.",
				column: "1",
			},
			{
				text: "Mejorar la comunicación de la flota.",
				column: "1",
			},
			{
				text: "Permitir una mejor y más rápida toma de decisiones.",
				column: "1",
			},
			{
				text: "Ahorro general al monitorear los hábitos de manejo.",
				column: "1",
			},
			{
				text: "Reducir el tiempo de respuesta.",
				column: "1",
			},
			{
				text: "Facilita llevar un control de los canales de distribución de forma eficiente.",
				column: "1",
			},
			{
				text: "Ayudar a mejorar el control del estado de la flota vehicular.",
				column: "2",
			},
			{
				text: "Ideal para la industria de transporte de largas distancias.",
				column: "2",
			},
			{
				text: "Mejorar la satisfacción del cliente.",
				column: "2",
			},
			{
				text: "Aumentar el número de paradas de servicio por día.",
				column: "2",
			},
			{
				text: "Aumento de la seguridad de la flota y la fuerza de trabajo.",
				column: "2",
			},
			{
				text: "Soporte de servicio 24/7.",
				column: "2",
			},
		],
		caracteristicas_red_title: "CARACTERÍSTICAS",
		caracteristicas_bold_title:
			"Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		caracteristicas_list: [
			"Sistema de localización vía GPS y dispositivos móviles.",
			"Generador de geocercas, puntos de interés y rutas.",
			"Visibilidad de vehículos sobre mapas digitalizados y fotos satelitales (Google Maps y OSM).",
			"Diversidad de reportes de gestión de conductores y flotas.",
			"Programar envío recurrente de reportes.",
			"Alertas en tiempo real de incidencias de seguridad y logística.",
			"Apagado remoto del vehículo y detección de manipulación del dispositivo.",
			"Manejo de distintos tipos de vehículos.",
			"Gestión de horas de manejo por conductor.",
			"Administración de usuarios por roles.",
		],
		funcionalidades_red_title: "FUNCIONALIDADES ESPECIALES",
		funcionalidades_bold_text:
			"Foresight GPS ha desarrollado integraciones con distintos tipos de periféricos y sensores de la más amplia gama en marcas, modelos y funcionalidades",

		funcionalidades_text: [
			"Esto dota de una gran versatilidad al sistema y le permite controlar variables y establecer acciones de forma remota.Desde la detección de un consumo atípico de combustible, pasando por un reporte detallado del comportamiento del motor y una medición de variaciones de temperatura de carga refrigerada. Incluso desde Foresight GPS podemos hacer nuevos desarrollos para integrar cualquier otro tipo de dispositivo.",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Fue diseñado para visualizar los indicadores clave de rendimiento de forma rápida y eficiente, facilitando la toma de decisiones ante grandes volúmenes de datos.",
		dashboard_bold_text:
			"Con distintos conjuntos de tableros puedes ver la velocidad media, máxima y promedio de la flota, el kilometraje por unidad, el consumo de combustible promedio individual o por flota, las horas del motor encendido y el tiempo en los viajes, y más.",

		dashboard_text: [
			"Además se pueden incluir nuevos sets de datos y personalizar los Dashboard a las necesidad específicas de cada operación.",
		],
		dashboard_list: [
			"Procesamiento de data.",
			"Presentación gráfica de resultados.",
			"Comparativo de resultados entre diferentes equipos.",
			"Identificador de variables fuera de rango.",
			"Interfaz gráfica amigable y fácil de leer.",
			"Control de múltiples variables de manera simultánea.",
			"Información discriminada en conductor/vehículo y flota.",
		],
		router_red_title: "ROUTER CENTER",
		router_bold_title:
			"Llevar un control de las rutas de los conductores ayuda a completar más tareas en menos tiempo mientras mantienen contentos a sus clientes y reduce costos operativos.",

		router_bold_text:
			"La planificación diaria no tiene porqué ser un dolor de cabeza con nuestro módulo de Route Center. A su vez, incrementa la puntualidad en las entregas y disfruta de una gestión eficiente.",
		router_text: [
			"Mediante la planificación, el diseño y la asignación de ruta, gerencia el trabajo de tu flota de una manera eficiente. Realiza un seguimiento de las rutas y la actividad diaria de la flota y sus rutas en tiempo real o a través de reportes lleva el seguimiento de tu flota y valida el cumplimiento de tarea.",
		],
		router_list: [
			"Mapeo de clientes y zonas de despacho.",
			"Creación de rutas.",
			"Planificación de visitas.",
			"Verificación de patrones de visitas.",
			"Variedad de reportes ejecutados.",
			"Visualización de avances de gestión de pantalla",
		],
	},
	english: {
		header_title: "Management ",
		header_title_yellow: "Fleet",
		flotas_red_title: "FLEET MANAGEMAENT",
		flotas_bold_title:
			"Managing commercial fleets is usually a complex process due to the scale of mobile assets and the variety of factors that must be controlled at the same time",
		flotas_bold_text:
			"For this reason, at ForesightGPS we have developed a platform that adapts to your needs, it allows you to access and manage the values of your commercial fleet.",
		flotas_text: [
			"The G-Evolution platform guarantees you fuel savings and fleet efficiency with its route tracking solution.",
			"Our platform is fully customizable and adaptable to your needs, allowing you to make faster and beneficial decisions for your business.",
		],
		beneficios_red_title: "BENEFITS",
		beneficios_bold_text:
			"Protect your mobile and business assets with the many benefits ForesightGPS offers you, such as:",
		beneficios_list: [
			{
				text: "Reducing maintenance costs.",
				column: "1",
			},
			{
				text: "Improve fleet communication.",
				column: "1",
			},
			{
				text: "Allow better and faster decision making.",
				column: "1",
			},
			{
				text: "Overall savings by monitoring driving habits.",
				column: "1",
			},
			{
				text: "Reduce response time.",
				column: "1",
			},
			{
				text: "Easy tracking of distribution channels.",
				column: "1",
			},
			{
				text: "Improve control over the state of the fleet.",
				column: "2",
			},
			{
				text: "Ideal for long distance transportation industry.",
				column: "2",
			},
			{
				text: "Improve customer satisfaction.",
				column: "2",
			},
			{
				text: "Increase of service stops per day.",
				column: "2",
			},
			{
				text: "Increase fleet and workforce safety.",
				column: "2",
			},
			{
				text: "24/7 suppor.",
				column: "2",
			},
		],
		caracteristicas_red_title: "FEATURES",
		caracteristicas_bold_title:
			"We have the best technological innovations for the optimal tracking of your mobile assets:",
		caracteristicas_list: [
			"Location system via GPS and mobile devices.",
			"Addition of geofences, points of interests and routes.",
			"Vehicle visibility on digital maps and satellite photos (Google Maps and OSM).",
			"Variety of reports on driver and fleet management .",
			"Schedule report sending.",
			"Real time alerts of security and logistics incidents",
			"Device tampering detection and remote vehicle shutdown.",
			"Handling of different types of vehicles.",
			"Management of driving hours per driver.",
			"User management by roles.",
		],
		funcionalidades_red_title: "ESPECIAL FUNCTIONALITIES",
		funcionalidades_bold_text:
			"ForesightGPS has developed integration with different kinds of peripherals and sensors of the widest range of brands, models, and functionalities.",

		funcionalidades_text: [
			"This allows the system great versatility and remote control of variables and sets of actions.From the detection of atypical fuel consumption, going through a detailed report of the behavior of the engine and measurements of variations in temperature of refrigerated cargo; ForesightGPS can make new developments to integrate any other type of device.",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Designed to display key performance indicators quickly and efficiently, facilitating      decision making when faced with large volumes of data.",
		dashboard_bold_text:
			"With different sets of dashboards allow you to view fleet average, maximum and average speed, milage per unit, average of fuel consumption of the fleet or individual, engine running hours, and more.",

		dashboard_text: [
			"Also can be customized to the specific needs of operation, including new data sets. ",
		],
		dashboard_list: [
			"Data processing.",
			"Graphic presentation of results.",
			"Comparison of results between different vehicles.",
			"Out of range variable identifier.",
			"Friendly and easy-to-read graphical interface.",
			"Simultaneous control of multiple variables.",
			"Information on driver, vehicle, and fleet.",
		],
		router_red_title: "ROUTER CENTER",
		router_bold_title:
			"Keeping track of drivers’ routes helps you complete more tasks in less time all while keeping your customers happy and reducing operating costs.",

		router_bold_text:
			"The daily planning does not have to be a headache with our route center module, it increases punctuality in deliveries and efficient management.",
		router_text: [
			"By planning, designing and assigning routes, manage the work of your fleet in an efficient way. Track routes and daily activity of the fleet and its routes in real time or through reports keep track of your fleet and validate task compliance.",
		],
		router_list: [
			"Mapping clients and dispatch areas.",
			"Route creation.",
			"Visit planning.",
			"Verification of visit patterns.",
			"Variety of executed reports.",
			"Viewing screen of management process.",
		],
	},
};

export default language;